import { type FormEvent, useState } from 'react';

import { useAuth } from '../auth/AuthContext';

export function LoginPage() {
  const { error, isLoading, login, sessionExpired } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  async function submit(event: FormEvent) {
    event.preventDefault();
    await login(username, password).catch(() => undefined);
  }

  return (
    <main className="login-page">
      <section className="login-panel">
        <div className="brand brand--login"><span className="brand__mark">LE</span><span><strong>LiquidEdge</strong><small>GTM Console</small></span></div>
        <h1>Sign in to GTM</h1>
        <p className="login-panel__intro">Sign in with your LiquidEdge Admin account. Customer and venue-operator accounts cannot access GTM.</p>
        <form className="form-stack" onSubmit={(event) => void submit(event)}>
          {sessionExpired ? <p className="inline-alert" role="status">Your session has expired. Sign in again to continue. Automation continues independently.</p> : null}
          <label><span>Admin login</span><input autoComplete="username" onChange={(event) => setUsername(event.target.value)} required type="text" value={username} /></label>
          <label><span>Password</span><input autoComplete="current-password" onChange={(event) => setPassword(event.target.value)} required type="password" value={password} /></label>
          {error ? <div className="inline-alert inline-alert--error" role="alert">Sign-in failed. Check your access and try again.</div> : null}
          <button className="button button--wide" disabled={isLoading} type="submit">{isLoading ? 'Signing in…' : 'Sign in securely'}</button>
        </form>
        <small className="login-panel__footnote">LiquidEdge platform administrators only</small>
      </section>
      <aside className="login-visual" aria-hidden="true"><div className="signal signal--one" /><div className="signal signal--two" /><div className="signal signal--three" /><div className="login-visual__copy"><strong>Weekly Active Sites</strong><span>The north-star metric, with every decision tied back to evidence.</span></div></aside>
    </main>
  );
}
